<template>
  <multiselect
    ref="multiselect"
    :value="value"
    :options="options"
    :multiple="true"
    :close-on-select="false"
    :clear-on-select="false"
    :preserve-search="true"
    :placeholder="placeholder"
    label="name"
    track-by="value"
    class="field-input__inner form__input select-with-checkbox"
    @input="onInput"
    @close="$emit('close')"
    @open="openDropDown"
  >
    <span slot="noResult">Ничего не найдено</span>

    <template
      slot="selection"
      slot-scope="{ values, search, isOpen }"
    >
      <span
        v-if="values.length &amp;&amp; !isOpen"
        class="multiselect__single"
      >Категорий выбрано: {{ values.length }}</span>
    </template>
    <template
      slot-scope="{ toggle }"
      slot="caret">
      <div @mousedown.prevent.stop="toggle()" class="multiselect__select">
        <svg
          width="24px"
          height="24px"
        >
          <use xlink:href="#arrow-down" />
        </svg>
      </div>
    </template>
  </multiselect>
</template>
<script>
import Multiselect from 'vue-multiselect';
import scrollToEl from '../../mixins/scrollToEl';

export default {
  name: 'SelectWithCheckbox',
  mixins: [scrollToEl],
  components: {
    Multiselect,
  },
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: [Object, String],
      default: null,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  methods: {
    onInput(value) {
      this.$emit('input', value);
    },
    openDropDown() {
      this.scrollToEl(this.$refs.multiselect);
    },
  },
};
</script>
<style lang="scss">
.select-with-checkbox {
  .multiselect__placeholder {
    color: #9fb3c3;
  }
  .multiselect__tags-wrap {
    display: none !important;
  }
  .multiselect__tags {
    color: #3f3f3f;
  }
  .multiselect__select {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 38px;
    padding: 4px 8px;
    text-align: center;
    transition: transform .2s ease;
    top: 50%;
    right: 6px;
    transform: translateY(-50%);
    z-index: 1;
    cursor: pointer;
    outline: none;
    .arrow-icon {
      position: static;
      top: unset;
      transform: none;
    }
  }
  .multiselect__option {
    position: relative;
    padding-left: 48px;
    &:before {
      position: absolute;
      display: block;
      content: "";
      border-radius: 3px;
      left: 16px;
      background: #fff;
      border: 1px solid #9fb3c3;
      -webkit-box-shadow: inset 3px 3px 0 0 #e7eaef;
      box-shadow: inset 3px 3px 0 0 #e7eaef;
      width: 20px;
      height: 20px;
      -webkit-transition: .3s all cubic-bezier(.4,0,.6,1);
      transition: .3s all cubic-bezier(.4,0,.6,1);
      top: 50%;
      -webkit-transform: translate(0,-50%);
      transform: translate(0,-50%);
      box-sizing: border-box;
    }
    &:after {
      position: absolute;
      display: block;
      content: "";
      left: 21px;
      width: 10px;
      height: 10px;
      opacity: 0;
      background-image: url("data:image/svg+xml,%3Csvg width='10' height='10' viewBox='0 0 10 10' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9 1L4.55 9 1 5.181' stroke='%23A6CE39' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
      visibility: hidden;
      -webkit-transition: .3s all cubic-bezier(.4,0,.6,1);
      transition: .3s all cubic-bezier(.4,0,.6,1);
      top: 50%;
      -webkit-transform: translate(0,-50%);
      transform: translate(0,-50%);
    }
    &.multiselect__option--selected:after {
      opacity: 1;
      visibility: visible;
    }
  }
  .multiselect__content-wrapper {
    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      -webkit-box-shadow: none;
      border-radius: 0;
      background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
      height: 44px;
      border-radius: 8px;
      background-color: #DADADA;
      outline: none;
      -webkit-box-shadow: none;
    }
  }
}

.multiselect--active.select-with-checkbox .multiselect__select {
  .arrow-icon {
    color: #ED1651;
  }
}
</style>
